<template>
    <!-- Two columns if vertical -->
    <TopicGroupTwoColumn v-if="!horizontal" key="technology-two-column">
        <!-- topics -->
        <template v-slot:column1>
            <internal-data/>
            <external-data class="topic--external-data"/>
        </template>
        <template v-slot:column2>
            <business-intelligence/>
            <data-science/>
            <artificial-intelligence/>
        </template>
        <!-- animations -->
        <template v-slot:animations>
            <internal-data-animation :delay="0" :interval="10000"/>
            <external-data-animation :delay="300" :interval="10000"/>
            <business-intelligence-animation :delay="0" :interval="10000"/>
            <data-science-animation :delay="0" :interval="10000"/>
            <artificial-intelligence-animation :delay="0" :interval="10000"/>
        </template>
    </TopicGroupTwoColumn>
    <!-- One column if horizontal -->
    <TopicGroup v-else key="technology-one-column">
        <!-- topics -->
        <internal-data></internal-data>
        <external-data class="topic--external-data"/>
        <business-intelligence/>
        <data-science/>
        <artificial-intelligence/>
        <!-- animations -->
        <template v-slot:animations>
            <internal-data-animation :delay="0" :interval="10000"/>
            <external-data-animation :delay="300" :interval="10000"/>
            <business-intelligence-animation :delay="0" :interval="10000"/>
            <data-science-animation :delay="0" :interval="10000"/>
            <artificial-intelligence-animation :delay="0" :interval="10000"/>
        </template>
    </TopicGroup>
</template>

<script>
import TopicGroup from '../TopicGroup'
import TopicGroupTwoColumn from '../TopicGroupTwoColumn'
import { technology } from '@/assets/svg-components'
import { technologyAnimations } from '../TopicAnimations'

export default {
    components: {
        TopicGroup,
        TopicGroupTwoColumn,
        ...technology,
        ...technologyAnimations
    },

    computed: {
        horizontal() {
            return this.$store.state.layout === 'horizontal'
        }
    }
}
</script>

<style lang="stylus">
.topic--external-data {
    margin-bottom: 2em !important;
}
</style>